export const transformControls = 'mp.transformControls';

export enum TransformationMode {
  TRANSLATE = 'translate',
  ROTATE = 'rotate',
  SCALE = 'scale',
}
